'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { DEFAULT_LOCALE } from '@/config/i18n';

export default function LangSetter({ locale }) {
  const pathname = usePathname();

  useEffect(() => {
    // Extract locale from pathname as fallback
    const pathLocale = pathname.match(/^\/(en|es|it)(\/|$)/)?.[1];
    const finalLocale = locale || pathLocale || DEFAULT_LOCALE;
    
    // Set lang attribute immediately
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('lang', finalLocale);
    }
  }, [locale, pathname]);

  return null;
}
